import React, { ReactNode } from 'react';
interface SectionHeadingProps {
  label?: string;
  title: ReactNode;
  intro?: ReactNode;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  as?: 'h1' | 'h2';
  className?: string;
}
export function SectionHeading({
  label,
  title,
  intro,
  tone = 'light',
  align = 'left',
  as = 'h2',
  className = ''
}: SectionHeadingProps) {
  const Heading = as;
  const dark = tone === 'dark';
  return <div className={`${align === 'center' ? 'mx-auto text-center' : ''} max-w-3xl ${className}`} data-id="element-494" data-mp="mzq2czyo1x4n">
      {label && <p className={`font-serif text-xl italic ${dark ? 'text-copper-light' : 'text-copper-deep'}`} data-id="element-495" data-mp="i76e992crjll">{label}</p>}
      <Heading className={`${label ? 'mt-3' : ''} text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-[2.75rem] ${dark ? 'text-porcelain' : 'text-aubergine'}`} data-id="element-496" data-mp="d9eksam27pfa">
        {title}
      </Heading>
      {intro && <p className={`mt-6 text-lg leading-relaxed ${align === 'center' ? 'mx-auto' : ''} max-w-2xl ${dark ? 'text-porcelain/75' : 'text-plum/70'}`} data-id="element-497" data-mp="3veqayaiayd1z">
          {intro}
        </p>}
    </div>;
}